var s = function s(i) {
    i && (i.style.opacity = "1", i.style.visibility = "visible");
  },
  t = function t(i) {
    i && (i.style.opacity = "0", i.style.visibility = "hidden");
  },
  o = {
    show: s,
    hide: t
  };
export { o as visibilityControls };